module.exports = __webpack_public_path__ + "img/ANTENNA RADIO 2 BW.49c9c6a.svg";